@if(isLoading()){
<app-loading-spinner text="page"></app-loading-spinner>
} @if (formFieldOptions$ | async; as data) {
<div class="w-full max-w-[840px] mx-auto p-3 pb-8 flex flex-col gap-3">
  <div class="w-full flex flex-row items-end justify-between">
    <p class="text-3xl font-md">
      {{ isRepost() ? "Repost" : "New" }} {{ lotType() | titlecase }}
    </p>
    <button
      type="button"
      class="text-custom-orange text-lg"
      (click)="cancel()"
    >
      Cancel
    </button>
  </div>
  <form
    class="form w-full flex flex-col gap-6"
    [formGroup]="newLotForm"
    (ngSubmit)="onSubmit()"
  >
    <!-- Contract Details -->
    <mat-card class="p-4">
      <mat-card-header class="mb-4 w-full pb-2">
        <mat-card-title class="flex items-center gap-2 !font-medium"
          ><span class="w-1 h-5 rounded bg-custom-orange"></span>Contract
          Details</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <div class="flex flex-col gap-3">
          <mat-form-field>
            <mat-label>Market Type</mat-label>
            <mat-select
              formControlName="market_type"
              (selectionChange)="onMarketChange($event.value)"
            >
              @for(market of userDetails().market_options; track market){
              @switch(market){ @case('Feed'){
              <mat-option [disabled]="isRepost()" [value]="market"
                >Domestic</mat-option
              >
              } @default{
              <mat-option [disabled]="isRepost()" [value]="market">{{
                market
              }}</mat-option>
              } } }
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Time Frame</mat-label>
            <mat-select formControlName="time_frame">
              @for(timeFrame of timeFrameOptions(); track timeFrame){
              <mat-option [value]="timeFrame">{{ timeFrame }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <div class="text-sm opacity-70 -mt-3">
            @switch (newLotForm.get('time_frame').value) { @case('Day'){ Day
            bids/offers will remain active until the market closes at 5 PM MDT
            if created prior to the closing hours, or until the subsequent day's
            market closure if created thereafter } @case('Week'){ Week lots will
            remain active for 7 Calendar days until 5 PM MDT } @case('GTC'){ GTC
            (Good Until Canceled) lots will persist until manually withdrawn by
            the user } @default { } }
          </div>
        </div>
        @if (showIndication()) {
        <div
          class="w-full mt-2 p-4 rounded-lg bg-eco-accent/40 dark:bg-white/5 flex flex-col gap-1"
        >
          <div class="flex flex-row items-center justify-between w-full">
            <span class="font-semibold">Indication</span>
            <mat-checkbox
              color="primary"
              formControlName="indication"
              labelPosition="before"
            >
            </mat-checkbox>
          </div>
          <span class="text-sm">
            A Bid/Offer indication represents a
            <span class="font-medium">non-binding expression of interest</span>
            from a buyer (<span class="font-medium">bid</span>) or seller
            (<span class="font-medium">offer</span>) to transact at a specific
            price or within a price range. It is used to gauge market sentiment
            and initiate potential negotiations, without guaranteeing execution.
          </span>
        </div>
        }
      </mat-card-content>
    </mat-card>
    <!-- Product Details -->
    <mat-card class="p-4">
      <mat-card-header class="mb-4 w-full pb-2">
        <mat-card-title class="flex items-center gap-2 !font-medium"
          ><span class="w-1 h-5 rounded bg-custom-orange"></span>Product
          Details</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <div class="flex flex-col gap-3">
          <mat-form-field>
            <mat-label>Origin</mat-label>
            <mat-select formControlName="origin">
              @for(origin of fieldOptions().origins; let i = $index; track i){
              <mat-option [value]="origin.name">{{ origin.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <app-select-filter
            placeholder="Search"
            label="Crop"
            [options]="commodities()"
            [optionGroup]="favouriteCommodities()"
            optionGroupTitle="Favourite Commodities"
            formControlName="commodity"
          ></app-select-filter>
          @if(productTypes() ){
          <app-select-filter
            placeholder="Search"
            label="Product Type"
            [options]="productTypes()"
            formControlName="product_type"
          ></app-select-filter>
          } @if(grades()){
          <app-select-filter
            placeholder="Search"
            label="Grade"
            [options]="grades()"
            formControlName="grade"
          ></app-select-filter>
          }
        </div>
      </mat-card-content>
    </mat-card>
    <!-- Specifications -->
    @if(newLotForm.get('specifications').length){
    <mat-card class="p-4">
      <mat-card-header class="mb-4 w-full pb-2">
        <mat-card-title class="flex items-center gap-2 !font-medium"
          ><span class="w-1 h-5 rounded bg-custom-orange"></span
          >Specifications</mat-card-title
        >
      </mat-card-header>
      <mat-card-content class="w-full">
        <div
          formArrayName="specifications"
          class="w-full grid grid-cols-1 mobile-min:grid-cols-2 gap-x-4"
        >
          @for ( spec of newLotForm.get('specifications').controls; track spec;
          let i = $index) {
          <mat-form-field [formGroupName]="i">
            <mat-label>{{ spec.get("title").value }}</mat-label>
            <input matInput type="text" formControlName="value" />
          </mat-form-field>
          }
        </div>
      </mat-card-content>
    </mat-card>
    }
    <!-- Delivery -->
    <mat-card class="p-4">
      <mat-card-header class="mb-4 w-full pb-2">
        <mat-card-title class="flex items-center gap-2 !font-medium"
          ><span class="w-1 h-5 rounded bg-custom-orange"></span
          >Delivery</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <div class="grid grid-cols-1 mobile-min:grid-cols-2 gap-x-4">
          <mat-form-field>
            <mat-label>Delivery Type</mat-label>
            <mat-select formControlName="delivery_type">
              @for(delType of fieldOptions().deliveryTypes; let i = $index;
              track i){
              <mat-option [value]="delType.name">{{ delType.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if(deliveryType()?.delivery_options?.length){
          <mat-form-field>
            <mat-label>Delivery Option</mat-label>
            <mat-select formControlName="delivery_option">
              @for(opt of deliveryType().delivery_options; let i = $index; track
              i){
              <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @if(deliveryType()?.container_types){
          <mat-form-field>
            <mat-label>Container Type</mat-label>
            <mat-select formControlName="container_type">
              @for(opt of deliveryType().container_types; let i = $index; track
              i){
              <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @if(deliveryType()?.packaging_types){
          <mat-form-field>
            <mat-label>Packaging</mat-label>
            <mat-select formControlName="packaging">
              @for(opt of deliveryType().packaging_types; let i = $index; track
              i){
              <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @if(deliveryType()?.tolerances){
          <mat-form-field>
            <mat-label>Tolerance</mat-label>
            <mat-select formControlName="tolerance">
              @for(opt of deliveryType().tolerances; let i = $index; track i){
              <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }
          <mat-form-field>
            <mat-label>Delivery Window</mat-label>
            <mat-date-range-input
              [rangePicker]="picker"
              [formGroup]="newLotForm.get('deliveryWindowControl')"
              [min]="minDate"
            >
              <input
                matStartDate
                [formControl]="newLotForm.get('deliveryWindowControl.start')"
                placeholder="Start date"
                [errorStateMatcher]="matcher"
              />
              <input
                matEndDate
                [formControl]="newLotForm.get('deliveryWindowControl.end')"
                placeholder="End date"
                [errorStateMatcher]="matcher"
              />
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker touchUi #picker></mat-date-range-picker>
            @if ( (newLotForm .get('deliveryWindowControl.start')
            .hasError('required') || newLotForm
            .get('deliveryWindowControl.end') .hasError('required')) &&
            (newLotForm.get('deliveryWindowControl').touched ||
            newLotForm.get('deliveryWindowControl').dirty) ) {
            <mat-error> Please enter a date range </mat-error>
            }
          </mat-form-field>
          <div class="flex flex-row gap-2 w-full mobile-min:col-span-2">
            <app-autocomplete
              class="w-full"
              label="Location"
              [autocompleteControl]="newLotForm.get('destination')"
              [required]="true"
              [options]="destinationsOptions()"
              [optGroup]="{
                title: recentlySearchedLocations().length
                  ? 'Recently Searched'
                  : null,
                list: recentlySearchedLocations()
              }"
            >
            </app-autocomplete>
            @if(searchingLocation()){
            <mat-spinner class="mt-3" [diameter]="35"></mat-spinner>
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <!-- Documentations -->
    @if(documentations()?.length){
    <mat-card class="p-4">
      <mat-card-header class="mb-4 w-full pb-2">
        <mat-card-title class="flex items-center gap-2 !font-medium"
          ><span class="w-1 h-5 rounded bg-custom-orange"></span
          >Documentations</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <div
          formArrayName="documentations"
          class="w-full grid grid-cols-1 mobile-min:grid-cols-2 gap-x-4"
        >
          @for ( doc of newLotForm.get('documentations').controls; track doc;
          let i = $index) {
          @if(documentations()[i]?.type === controlTypes.Text){
          <mat-form-field [formGroupName]="i">
            <mat-label>{{ doc.get("title").value }}</mat-label>
            <input matInput type="text" formControlName="value" />
          </mat-form-field>
          } @else if(documentations()[i]?.type == controlTypes.Select){
          <mat-form-field [formGroupName]="i">
            <mat-label>{{ doc.get("title").value }}</mat-label>
            <input
              matInput
              type="text"
              [matAutocomplete]="auto"
              formControlName="value"
            />
            <mat-icon
              aria-hidden="false"
              aria-label="clear icon"
              class="hover:cursor-pointer"
              fontIcon="arrow_drop_down"
              matSuffix
            ></mat-icon>
            <mat-autocomplete #auto="matAutocomplete">
              @for ( option of documentations()[i].options; track option; let j
              = $index) {
              <mat-option [value]="option">
                {{ option }}
              </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
          } }
        </div>
      </mat-card-content>
    </mat-card>
    }
    <!-- Price -->
    <mat-card class="p-4">
      <mat-card-header class="mb-4 w-full pb-2">
        <mat-card-title class="flex items-center gap-2 !font-medium"
          ><span class="w-1 h-5 rounded bg-custom-orange"></span
          >Price</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <div class="grid grid-cols-1 mobile-min:grid-cols-2 gap-x-4">
          @if (priceTypes().length >1) {
          <mat-form-field>
            <mat-label>Price Type</mat-label>
            <mat-select formControlName="price_type">
              @for (type of priceTypes(); track type) {
              <mat-option [value]="type">{{ type }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @if (deliveryType()) {
          <mat-form-field>
            <mat-label>Currency</mat-label>
            <mat-select formControlName="currency">
              @for (currency of deliveryType().currencies; let i = $index;track
              i) {
              <mat-option [value]="currency">
                {{ currency }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          }
        </div>
        @if (newLotForm.get('price_type').value === 'Basis') {
        <div class="flex flex-col" formGroupName="basis_price">
          <div class="grid grid-cols-2 tablet-min:grid-cols-4 gap-x-2">
            <mat-form-field>
              <mat-label>Basis Points</mat-label>
              <input
                type="number"
                formControlName="basisPoints"
                matInput
                [errorStateMatcher]="matcher"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Product Code </mat-label>
              <input
                type="text"
                formControlName="product_code"
                matInput
                [readonly]="true"
                [errorStateMatcher]="matcher"
              />
            </mat-form-field>
            <mat-form-field>
              <mat-label>Month</mat-label>
              <mat-select formControlName="month">
                @for(month of basisMonths; track month.label){
                <mat-option [value]="month.value" class="text-sm"
                  >{{ month.label }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Year</mat-label>
              <mat-select formControlName="year">
                @for(year of basisYears; track year){
                <mat-option [value]="year">{{ year }} </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if ( newLotForm.hasError('priceRequired') &&
          (newLotForm.get('basis_price').touched ||
          newLotForm.get('basis_price').dirty) ) {
          <mat-error class="text-sm"
            >Please enter a number greater than 0
          </mat-error>
          } @if ( newLotForm.get('basis_price.basisPoints')
          .hasError('pattern') && newLotForm.get('basis_price').get('basisPoints').dirty
          && newLotForm.get('price_type').value === 'Basis' ) {
          <mat-error class="text-sm"
            >Price should not exceed 4 decimal places
          </mat-error>
          }
        </div>
        }
        <div class="w-full grid grid-cols-3 gap-x-2">
          @if (newLotForm.get('price_type').value === 'Basis') {
          <mat-form-field class="col-span-2" formGroupName="basis_price">
            <mat-label>Basis Quote</mat-label>
            <input
              [readonly]="true"
              type="text"
              matInput
              [value]="basisQuote()"
              [errorStateMatcher]="matcher"
            />
          </mat-form-field>
          } @if (newLotForm.get('price_type').value === 'Cash') {
          <mat-form-field class="col-span-2">
            <mat-label>Price</mat-label>
            <input
              type="number"
              matInput
              formControlName="priceControl"
              [errorStateMatcher]="matcher"
              placeholder="0.00"
            />
            <span matTextSuffix class="text-sm opacity-60 pl-2">{{
              newLotForm.controls.currency.value
            }}</span>

            @if ( newLotForm.hasError('priceRequired') && (
            newLotForm.get('priceControl').dirty||
            newLotForm.get('priceControl').touched) &&
            newLotForm.get('price_type').value === 'Cash' ) {
            <mat-error>Please enter a number greater than 0 </mat-error>
            } @if(newLotForm.get('priceControl').hasError('pattern') &&
            (newLotForm.get('priceControl').touched ||
            newLotForm.get('priceControl').dirty ) &&
            newLotForm.get('price_type').value === 'Cash' ){
            <mat-error>
              Can only allow postive numbers up to 4 decimal places
            </mat-error>
            }
          </mat-form-field>
          } @if (deliveryType()?.price_units.length) {
          <mat-form-field>
            <mat-label>Price Units</mat-label>
            <mat-select formControlName="price_units">
              @for (unit of deliveryType().price_units; let i = $index; track i)
              {
              <mat-option [value]="unit">{{ unit }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }
        </div>
        <div class="grid grid-cols-3 gap-x-2 w-full">
          <mat-form-field class="col-span-2">
            <mat-label>Quantity</mat-label>
            <input
              type="number"
              matInput
              formControlName="volume_value"
              [errorStateMatcher]="matcher"
              placeholder="0"
            />
            @if ( newLotForm.get('volume_value').hasError('pattern') ||
            (newLotForm.get('volume_value').hasError('required') &&
            (newLotForm.get('volume_value').touched ||
            newLotForm.get('volume_value').dirty)) ) {
            <mat-error>Please enter an integer number greater than 0</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Units</mat-label>
            <mat-select formControlName="units">
              @for (unit of volumeUnits(); track unit.name_short) {
              <mat-option [value]="unit.name_short">{{
                unit.name_short
              }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
    <!-- Payment Terms -->
    @if(deliveryType()?.rules_to_govern ||
    deliveryType()?.weight_grade_to_govern || deliveryType()?.payment_terms){
    <mat-card class="p-4">
      <mat-card-header class="mb-4 w-full pb-2">
        <mat-card-title class="flex items-center gap-2 !font-medium"
          ><span class="w-1 h-5 rounded bg-custom-orange"></span>Payment
          Terms</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        <div class="grid grid-cols-1 mobile-min:grid-cols-2 gap-x-4">
          @if(deliveryType()?.rules_to_govern){
          <mat-form-field>
            <mat-label>Governing Rule</mat-label>
            <mat-select formControlName="rules_to_govern">
              @for(opt of deliveryType().rules_to_govern; let i = $index; track
              i){
              <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @if(deliveryType()?.weight_grade_to_govern){
          <mat-form-field>
            <mat-label>Weight/Grade To Govern</mat-label>
            <mat-select formControlName="weight_grade_to_govern">
              @for(opt of deliveryType().weight_grade_to_govern; let i = $index;
              track i){
              <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          } @if(deliveryType()?.payment_terms){
          <mat-form-field>
            <mat-label>Payment Terms</mat-label>
            <mat-select formControlName="payment_term">
              @for(opt of deliveryType().payment_terms; let i = $index; track
              i){
              <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }
        </div>
      </mat-card-content>
    </mat-card>
    }
    <!-- Additional Notes or Terms -->
    <mat-card class="p-4">
      <mat-card-header class="w-full mb-4 pb-2">
        <mat-card-title class="flex items-center gap-2 !font-medium"
          ><span class="w-1 h-5 rounded bg-custom-orange"></span>Additional
          Notes or Terms</mat-card-title
        >
      </mat-card-header>
      <mat-card-content class="w-full">
        <mat-form-field>
          <mat-label>Additional info</mat-label>

          <textarea
            maxlength="280"
            rows="4"
            matInput
            formControlName="additional_info"
            placeholder="Add any terms, conditions, or notes for the counterparty..."
          ></textarea>
          <mat-hint align="end"
            >{{ newLotForm.controls.additional_info.value?.length ?? 0 }}/280
          </mat-hint>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <div class="w-full flex flex-row justify-center sticky bottom-5">
      <button matButton="filled" type="submit">Submit</button>
    </div>
  </form>
</div>
}
